import { ComponentProps, CSSProperties } from 'react';
import { LinkNext } from '../link/link';

type Mappable = {
  name?: string | null;
  address?: {
    street?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    location?: {
      lat: number;
      lon: number;
    } | null;
  } | null;
};

export const MapLink = (
  props: Omit<ComponentProps<typeof LinkNext>, 'href'> & {
    mappable: Mappable;
    css?: CSSProperties;
  },
) => {
  const { mappable, css, ...rest } = props;

  const lat = mappable.address?.location?.lat;
  const lon = mappable.address?.location?.lon;
  let queryComponents = [];
  if (lat != null && lon != null) {
    queryComponents = [lat, lon];
  } else {
    queryComponents = [
      mappable.name,
      mappable.address?.street,
      mappable.address?.city,
      mappable.address?.state,
      mappable.address?.zip,
    ];
  }

  return (
    <LinkNext
      href={`https://www.google.com/maps/search/?api=1&query=${queryComponents.filter(Boolean).join(',')}`}
      target="_blank"
      rel="noopener noreferrer"
      style={css}
      {...rest}
    />
  );
};
